import { Button, Card } from 'react-daisyui'
import { useAuth } from 'react-oidc-context';
import { NavLink } from 'react-router-dom';
export default function Index() {
  const auth = useAuth();
    return (
      <Card side="lg">
        <Card.Image
          src="/Life-Fit_Logo_2023.png"
          alt="Life-Fit Logo"
          style={{width: '150px', height: '150px'}}
        />
        <Card.Body>
          <Card.Title tag="h2">Life-Fit Learning</Card.Title>
          <p>Life-Fit-Learning is a fully integrated science-to-service model of care for young people.</p>
          <Card.Actions className="justify-end">
            {
              auth.isAuthenticated ?
              <NavLink
              to="studies"
              id="GetStartedButton"
              className={({ isActive, isPending }) =>
                isPending ? "pending btn btn-primary" : isActive ? "active btn btn-primary" : "btn btn-primary"
              }
              >
                Get Started
              </NavLink>
              :
              <Button className="btn-primary"
              onClick={() => auth.signinRedirect()}
              >Login to Get Started</Button>
            }

          </Card.Actions>
        </Card.Body>
      </Card>
    );
  }